import { Navigate } from 'react-router-dom'
import { useSession } from '@shared/hooks/useSession'
import { ReactNode } from 'react'
import { getPendingMfaToken } from '@shared/libs/authStorage'

export function MfaRoute({ children }: { children: ReactNode }) {
  const { data, isLoading } = useSession()
  const hasPending = Boolean(getPendingMfaToken())
  if (hasPending) return <>{children}</>
  if (isLoading) return <div className="p-6">Loading…</div>
  if (!data?.needs_mfa) return <Navigate to="/" replace />
  return <>{children}</>
}
